
import Vue from 'vue'
import MarkdownIt from 'markdown-it'


export default Vue.extend({
  computed: {
    productDetailMD(): string {
      return this.$store.state.productDetailMD
    },
    productDescription(): string {
      return this.$store.state.productDescription
    },
    productDetailHtml(): string {
      if (!this.productDetailMD) return ''
      const md = new MarkdownIt({
        html: true
      })
      return md.render(this.productDetailMD)
    },
    productCategoryAttributes(): { name: string, value: string }[] {
      return this.$store.state.productCategoryAttributes
    }
  }
})
